import Vue from 'vue'
import Vuetify, { VBtn } from 'vuetify/lib'
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify)

VBtn.options.props.ripple.default = false

export default new Vuetify({
  lang: {
    locales: {
      fr
    },
    current: `fr`
  }
  /* theme: {
    options: {
      themeCache: {
        get: key => localStorage.getItem(key),
        set: (key, value) => {
          localStorage.setItem(key, value)
        }
      }
    }
  } */
})
